import Logo from '/img/main/logo.png';
import PartnerText from '/img/main/partner-text.png';
import ParticipateInfo from '/img/main/participation-info.png';
import ParticipateInfoActive from '/img/main/participation-info-active.png';
import SnsIcon1 from '/img/sns-icon1.png';
import SnsIcon2 from '/img/sns-icon2.png';
import SnsIcon3 from '/img/sns-icon3.png';
import SnsIcon4 from '/img/sns-icon4.png';
import GuideImg1 from '/img/guide/guide-img1.png';
import GuideImg2 from '/img/guide/guide-img2.png';
import GuideImg3 from '/img/guide/guide-img3.png';
import GuideImg3_1 from '/img/guide/guide-img3_1.png';
import GuideImg4 from '/img/guide/guide-img4.png';
import NumberIcon1 from '/img/guide/number-icon1.png';
import NumberIcon2 from '/img/guide/number-icon2.png';
import NumberIcon3 from '/img/guide/number-icon3.png';
import NumberIcon4 from '/img/guide/number-icon4.png';
import Card from '/img/main/card.png';
import Check from '/img/check.png';
import CheckActive from '/img/check-active.png';
import QuestionIcon from '/img/main/question-icon.png';
import CloseIcon from '/img/close.png';
import WebFlareImage from '/img/main/web-flare.png';
import MobileFlareImage from '/img/main/mobile-flare.png';
import ShowDownApp from '/img/main/showdown-app.png';
import UnionIcon from '/img/main/union-icon.png';
import PartnerIcon from '/img/main/partner.png';
import KakaoIcon from '/img/main/kakao-icon.png';
import ArrowRightIcon from '/img/guide/arrow-right-icon.png';

export const ImageUtils = {
  Logo,
  PartnerText,
  ParticipateInfo,
  ParticipateInfoActive,
  SnsIcon1,
  SnsIcon2,
  SnsIcon3,
  SnsIcon4,
  GuideImg1,
  GuideImg2,
  GuideImg3,
  GuideImg3_1,
  GuideImg4,
  NumberIcon1,
  NumberIcon2,
  NumberIcon3,
  NumberIcon4,
  Card,
  Check,
  CheckActive,
  QuestionIcon,
  CloseIcon,
  WebFlareImage,
  MobileFlareImage,
  ShowDownApp,
  UnionIcon,
  PartnerIcon,
  KakaoIcon,
  ArrowRightIcon,
};
